import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import secureLocalStorage from "react-secure-storage";
import { Phone } from "lucide-react";
import Notification from "../../components/common/notification/Notification";
import MobileVerification from "../../components/verification/MobileVerification";
import { loginSuccess } from "../../features/auth/authSlice";
import Logo from "../../assets/images/logo.png";
import "./AuthForm.css";

const WhatsAppIcon = () => (
  <svg className="auth-form__whatsapp-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" fill="#25D366"/>
    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.122 1.532 5.857L0 24l6.306-1.508A11.95 11.95 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.797 9.797 0 01-5.003-1.373l-.36-.214-3.737.893.938-3.63-.235-.374A9.772 9.772 0 012.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" fill="#25D366"/>
  </svg>
);

const AuthForm = ({
  type,
  title,
  subtitle,
  redirectOnSuccess,
  footerText,
  footerLink,
  footerPath,
  userType,
}) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [verifiedResponse, setVerifiedResponse] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const savedAuth = secureLocalStorage.getItem("auth");
    if (savedAuth && savedAuth.token) {
      dispatch(loginSuccess(savedAuth));
      navigate("/dashboard/myspace", { replace: true });
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    if (verifiedResponse?.statusType === "SUCCESS") {
      dispatch(loginSuccess(verifiedResponse));
      secureLocalStorage.setItem("auth", verifiedResponse);
      secureLocalStorage.setItem("token", verifiedResponse.token);
      secureLocalStorage.setItem("refreshToken", verifiedResponse.refreshToken);
      navigate(redirectOnSuccess, { replace: true });
      window.location.reload();
    }
  }, [verifiedResponse, dispatch, navigate, redirectOnSuccess]);

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) setPhoneNumber(value);
  };

  return (
    <div className="auth-form">
      <Notification />

      <div className="auth-form__card">

        <div className="auth-form__left">
          <div className="auth-form__left-bg" />
          <div className="auth-form__left-gradient" />
          <div className="auth-form__left-content">
            <span className="auth-form__left-label">All Home Desire</span>
            <h2 className="auth-form__left-heading">
              Find Your <em>Perfect</em>
              <br />Home Today
            </h2>
            <p className="auth-form__left-text">
              Thousands of verified properties across India —
              transparent, effortless, and tailored to you.
            </p>
          </div>
        </div>

        <div className="auth-form__right">
          <img src={Logo} alt="All Home Desire" className="auth-form__logo" />

          <h1 className="auth-form__title">{title}</h1>
          <p className="auth-form__subtitle">{subtitle}</p>

          <div className="auth-form__field">
            <label className="auth-form__label">Mobile Number</label>
            <div className="auth-form__input-wrap">
              <span className="auth-form__input-icon">
                <Phone size={16} />
              </span>
              <span className="auth-form__input-divider" />
              <span className="auth-form__input-prefix">+91</span>
              <input
                className="auth-form__input"
                type="number"
                placeholder="Enter 10 digit number"
                value={phoneNumber}
                onChange={handlePhoneChange}
              />
            </div>
            <div className="auth-form__whatsapp-note">
              <WhatsAppIcon />
              OTP will be sent to your WhatsApp number
            </div>
          </div>

          <MobileVerification
            mobileNumber={"91" + phoneNumber}
            action={type}
            userType={userType}
            onMobileVerified={setVerifiedResponse}
            disabled={phoneNumber.length !== 10}
          />

          {footerText && footerLink && (
            <div className="auth-form__footer">
              {footerText}{" "}
              <Link to={footerPath}>{footerLink}</Link>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default AuthForm;